import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';
import device from 'utils/device'

const template = styled.div`
  ${({ displayState }) => css`
    position: fixed;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    border: 1px solid #E3E3E3;
    box-sizing: border-box;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: 12px 12px 0px 0px;
    padding: 20px 0px;
    bottom: 0px;
    width: 100%;
    z-index: 100;

    height: ${displayState?.swipe ? `${348 - displayState.swipe}px` : '348px'};
    overflow: auto;

    scrollbar-width: none;
    /* width */
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  `}
`;

export default Wrapper(template);